import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';

import { CoreWidgetsModule } from '../core.widgets.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { FileTypeService } from '../../plugins/tracker/services/file-type.service';
import { GfNotebookComponent } from './gf-notebook.component';

/**
 * Self-contained module for the shared <gf-notebook> component. Host modules
 * (tracker, user) import this to embed a notebook surface.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreWidgetsModule,
        CoreFiltersModule,
        MarkdownModule.forChild(),
    ],
    declarations: [
        GfNotebookComponent,
    ],
    exports: [
        GfNotebookComponent,
    ],
    providers: [
        FileTypeService,
    ],
})
export class NotebookModule {}
